import { configPromise } from "../../config/configMiddleware";
import { getWith, postWith } from "../axios";

export async function GetActivity(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/activity/`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function CreateActivity(message: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/activity/`;
    const msg = { message: message };
    return (await postWith<any, any>(url, msg)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function MarkAsRead(id: Number): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/activity/` + id;
    return (await postWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetDashboardCounts(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/dashboard/counts`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function MarkAllAsRead(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/activity/read-all`;
    return (await postWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getDashboardCountsForOrg(
  id: string | undefined,
  userId:string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-counts-v2/fetch-org-discovery-count/${id}?userId=${userId}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getDashboardCountsForPartner(
  id: string | undefined,
  userId:string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/discovery-counts-v2/fetch-partner-discovery-count/${id}?userId=${userId}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}